/** Fired when debounced IndexedDB export fails after a local SQLite mutation. */
export const LOCAL_SQLITE_PERSIST_FAILURE_EVENT = 'local-sqlite:persist-failure' as const;

export type LocalSqlitePersistFailureDetail = {
  readonly message: string;
  readonly phase: 'notify' | 'flush';
};

/** Notifies shell chrome that local SQLite could not be persisted to IndexedDB. */
export function dispatchLocalSqlitePersistFailure(detail: LocalSqlitePersistFailureDetail): void {
  globalThis.dispatchEvent(new CustomEvent(LOCAL_SQLITE_PERSIST_FAILURE_EVENT, { detail }));
}
